import {css} from "@emotion/react";

export const cardSwitchAnimationKeyFrame = css`
	@keyframes cardSwitchAnimation {
		0% {
			top: 0;
			//transform: translateY(0);
		}

		20% {
			top: 0;
			//transform: translateY(0);
		}

		35% {
			top: -50%;
			//transform: translateY(-50%);
		}

		70% {
			top: -50%;
			//transform: translateY(-50%);
		}

		85% {
			top: 0;
		}

		100% {
			top: 0;
			//transform: translateY(0);
		}
	}

	-webkit-animation: cardSwitchAnimation 4500ms forwards !important;
	animation: cardSwitchAnimation 4500ms forwards !important;
`;

export const rotateAnimationHandler = css`
	@keyframes rotateAnimation {
		from {
			-ms-transform: rotate(180deg);
			-moz-transform: rotate(180deg);
			-webkit-transform: rotate(180deg);
			-o-transform: rotate(180deg);
			transform: rotate(180deg);
		}
		to {
			-ms-transform: rotate(-180deg);
			-moz-transform: rotate(-180deg);
			-webkit-transform: rotate(-180deg);
			-o-transform: rotate(-180deg);
			transform: rotate(-180deg);
		}
	}

	-webkit-animation: rotateAnimation 1000ms infinite !important;
	animation: rotateAnimation 1000ms infinite !important;
`;

export function getFadeOutAnimation(duration: number) {
	const durationString = `${duration}ms`;
	const uuid = Math.floor(Math.random() * 1000);
	const animationName = `fade-out-${uuid}`;

	return css`
		@keyframes ${animationName} {
			0% {
				opacity: 1;
			}

			80% {
				opacity: 1;
			}

			100% {
				opacity: 0;
			}
		}

		animation: ${durationString} ${animationName} forwards;
	`;
}

export function getFadeInAnimation(duration: number, important = false) {
	const durationString = `${duration}ms`;
	const uuid = Math.floor(Math.random() * 1000);
	const animationName = `fade-in-${uuid}`;

	const importance = important ? "!important" : "";

	return css`
		@keyframes ${animationName} {
			0% {
				opacity: 0;
			}

			80% {
				opacity: 0;
			}

			100% {
				opacity: 1;
			}
		}

		animation: ${durationString} ${animationName} forwards ${importance};
	`;
}

export function getTransitionYAnimation(duration: number, index: number) {
	const durationString = `${duration}ms`;
	const uuid = Math.floor(Math.random() * 1000);
	const animationName = `transition-${uuid}`;

	return css`
		@keyframes ${animationName} {
			0% {
				transform: translateY(calc(100% * ${index + 1}));
			}

			80% {
				transform: translateY(calc(100% * ${index + 1}));
			}

			100% {
				transform: translateY(calc(100% * ${index}));
			}
		}

		animation: ${durationString} ${animationName} forwards;
	`;
}
